import CheckBoxChecked from '@/app/_components/Icon/CheckBoxChecked'
import CheckBoxOutline from '@/app/_components/Icon/CheckBoxOutline'
import { cn } from '@/app/_primitives/utils/cn'
import React, { useTransition } from 'react'

export default function Checkbox({
  children,
  checked,
  onChecked,
  className,
}: {
  children: React.ReactNode
  checked: boolean
  onChecked: (_: boolean) => unknown
  className?: string
}) {
  const [isPending, startTransition] = useTransition()

  return (
    <button
      onClick={() => {
        startTransition(() => {
          onChecked(!checked)
        })
      }}
      type="button"
      className={cn(
        'flex cursor-pointer flex-row items-center gap-10 outline-none focus-visible:outline-none',
        {
          'cursor-wait': isPending,
        },
        className,
      )}>
      {checked && (
        <CheckBoxChecked className="shrink-0 fill-butterscotch [&_path]:fill-white" />
      )}
      {!checked && <CheckBoxOutline className="shrink-0 stroke-tertiary" />}
      <p className="c-b4 flex-1 text-[#4B5157]">{children}</p>
    </button>
  )
}
